



















































































import Component from 'vue-class-component';
import {Prop, Vue, Watch} from 'vue-property-decorator';
import {ResizeSensor} from 'css-element-queries';
import {throttle} from 'lodash';
import '@/compiled-icons/more';
import '@/compiled-icons/link';

interface InitializedResponsiveTabBarItem extends AmetrasResponsiveTabBarItem {
  showInThreeDotMenu?: boolean;
  width?: number;
}

export interface AmetrasResponsiveTabBarItem {
  text: string;
  title: string;
  icon?: string;
}

/**
 * This is a responsive Tab Bar implementation
 *
 * The tab bar will use all available space
 * If there is not enough space available in the tab bar, tabs will be moved to a separate three dot menu
 */
@Component({})
export default class AmetrasResponsiveTabBar extends Vue {

  // ATTENTION! This property CANNOT be reactive! re-render if changes are needed
  @Prop() tabs!: AmetrasResponsiveTabBarItem[];
  @Prop({
    default: 0
  }) value!: number;
  @Prop({
    default: false
  }) attachRelatively!: boolean;
  localTabs: InitializedResponsiveTabBarItem[] = [];
  hasAtLeastOneThreeDotMenuItem: boolean = false;
  threeDotMenuOpen: boolean = false;
  threeDotMenuButtonWidth: number = 36;

  throttledRearrange = throttle(() => {
    this.rearrange();
  }, 200);

  $refs!: {
    tabWrapper: HTMLDivElement
  };
  widthCalculation: boolean = true;
  private resizeSensor: ResizeSensor | undefined;

  @Watch('value') valueChanged(
      newValue: number
  ) {
    this.value = newValue;
    this.throttledRearrange();
  }

  created() {
    this.localTabs = [...this.tabs];
  }

  mounted() {
    this.initializeTabWidths().then(() => {
      this.resizeSensor = new ResizeSensor(this.$refs.tabWrapper, () => {
        this.throttledRearrange();
      });
      this.throttledRearrange();
      this.widthCalculation = false;
    });
  }

  beforeDestroy() {
    if (this.resizeSensor) {
      this.resizeSensor.detach();
    }
  }

  /**
   * Collects the width of all tab els.
   */
  private initializeTabWidths() {
    return new Promise<void>((resolve, reject) => {
      Vue.nextTick().then(() => {
        const allTabEls = (this.$refs as any).tab;
        for (let currentTabElIndex = 0; currentTabElIndex < allTabEls.length; currentTabElIndex++) {
          const currentTabEl = allTabEls[currentTabElIndex].$el as HTMLElement;
          const computedElValue = getComputedStyle(currentTabEl);
          this.localTabs[currentTabElIndex].width = (currentTabEl.clientWidth)
              + parseInt(computedElValue.marginLeft, 10)
              + parseInt(computedElValue.marginRight, 10);
        }
        resolve();
      });
    });
  }

  /**
   * Items that take more space than available will be moved to the "..." (three dot) menu
   */
  private rearrange() {
    Vue.nextTick().then(() => {
      const currentActiveTab: InitializedResponsiveTabBarItem = this.localTabs[this.value];
      const freeSpaceInPx = (this.$refs.tabWrapper as HTMLElement).clientWidth - 36;
      if (currentActiveTab.width === undefined) {
        throw new Error('Tab not initialized');
      }

      // free space = free space - active item width
      let freeSpaceAfterCurrentItem: number = freeSpaceInPx - currentActiveTab.width;

      const localTabsCopy = [...this.localTabs];
      let hasAtLeastOneThreeDotMenuItem = false;
      for (let currentTabIndex = 0; currentTabIndex < localTabsCopy.length; currentTabIndex++) {
        const currentItem = localTabsCopy[currentTabIndex];
        if (currentTabIndex === this.value) {
          // the active selected tab is never shown in the menu
          currentItem.showInThreeDotMenu = false;
          continue;
        }

        if (currentItem.width === undefined) {
          throw new Error('Tab not initialized');
        }

        freeSpaceAfterCurrentItem -= currentItem.width;
        const showInThreeDotMenu = freeSpaceAfterCurrentItem < 0;
        currentItem.showInThreeDotMenu = showInThreeDotMenu;
        hasAtLeastOneThreeDotMenuItem = hasAtLeastOneThreeDotMenuItem || showInThreeDotMenu;
      }
      this.localTabs = localTabsCopy;
      this.hasAtLeastOneThreeDotMenuItem = hasAtLeastOneThreeDotMenuItem;
      if (!hasAtLeastOneThreeDotMenuItem) {
        this.threeDotMenuOpen = false;
      }

      Vue.nextTick(() => {
        // Das Setzen des aktiven Tabs geht nicht, da bereits in Autofocus vorhanden ist
        // https://codesandbox.io/s/vuetify-active-tab-v-tabs-component-forked-oix81?file=/src/App.vue
        // https://github.com/vuetifyjs/vuetify/issues/10102
        window.dispatchEvent(new Event('resize'));
      });
    });
  }
}
